export const parsePositivePage = (value: string | null): number => {
  if (!value) return 1
  const parsed = Number.parseInt(value, 10)
  return Number.isFinite(parsed) && parsed > 0 ? parsed : 1
}

export const resolveProductsPageFromLocation = (): number => {
  if (typeof window === 'undefined') return 1
  const params = new URLSearchParams(window.location.search)
  return parsePositivePage(params.get('page'))
}

export const clampPage = (page: number, totalPages: number): number => {
  if (totalPages <= 1) return 1
  return Math.min(Math.max(page, 1), totalPages)
}

export const syncProductsPageQuery = (page: number, mode: 'push' | 'replace') => {
  if (typeof window === 'undefined') return
  const params = new URLSearchParams(window.location.search)
  if (page <= 1) params.delete('page')
  else params.set('page', String(page))

  const query = params.toString()
  const nextUrl = `${window.location.pathname}${query ? `?${query}` : ''}${window.location.hash}`
  const currentUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`
  if (nextUrl === currentUrl) return
  if (mode === 'push') {
    window.history.pushState(window.history.state, '', nextUrl)
    return
  }
  window.history.replaceState(window.history.state, '', nextUrl)
}
